import { useEffect, useState } from 'react';
import { CustomersTable } from './CustomerTable';
import { RoleSelector } from './RoleSelector';


export const CustomerSelector = ({context, roles, onCustomerSelect, onChangeRole}) => {
    const [state, setState] = useState({
        filteredCustomers: [],
        selectedRole: roles[0],
    });

    useEffect(() => {onChangeRole && onChangeRole(roles[0])}, []);

    const changeState = (partialState) => setState(currentState => ({...currentState, ...partialState}));

    return <>
        <RoleSelector
            roles={roles}
            selectedRole={state.selectedRole}
            onChangeRole={selectedRole => {
                changeState({selectedRole});
                onChangeRole && onChangeRole(selectedRole);
            }}
        />
        <CustomersTable
            context={context}
            role={state.selectedRole}
            onCustomerSelect={onCustomerSelect}
        />
    </>;
};
